var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import PropTypes from 'prop-types';

const ExtendedTooltip = (props) => {
  if (props.active) {
    const dataSetA = props.payload[0];
    const dataSetB = props.payload[1];

    return (/*#__PURE__*/
      _jsx("div", { style: { backgroundColor: '#fff', border: '1px solid #ccc' } }, void 0, /*#__PURE__*/
      _jsx("div", { style: { backgroundColor: '#eee', borderBottom: '1px dashed #ccc', padding: '5px' } }, void 0,
      dataSetA.payload.name, ":\xA0\xA0", /*#__PURE__*/
      _jsx("b", { style: { color: '#600' } }, void 0, dataSetA.value + dataSetB.value)
      ), /*#__PURE__*/
      _jsx("div", { style: { padding: '5px' } }, void 0,
      dataSetA.payload.setALabel, ":\xA0\xA0", /*#__PURE__*/_jsx("b", { style: { color: '#600' } }, void 0, dataSetA.value), /*#__PURE__*/
      _jsx("br", {}),
      dataSetB.payload.setBLabel, ":\xA0\xA0", /*#__PURE__*/_jsx("b", { style: { color: '#600' } }, void 0, dataSetB.value)
      )
      ));

  }
  return null;
};

ExtendedTooltip.defaultProps = {
  payload: [],
  active: false
};






export default ExtendedTooltip;